import { type CSSProperties, lazy, type LazyExoticComponent, type ReactNode } from 'react';
import type { JSX } from 'react/jsx-runtime';
import { use100vh } from 'react-div-100vh';
import { type Country, getConfig } from '@/constants/config';
import { cn } from '@/ui-kit/utils';

const HeaderSE = lazy(() => import('@/components/Layout/components/HeaderSE/HeaderSE'));
const HeaderUK = lazy(() => import('@/components/Layout/components/HeaderUK/HeaderUK'));
const HeaderFI = lazy(() => import('@/components/Layout/components/HeaderFI/HeaderFI'));

const HeaderCountryMap = {
  SE: HeaderSE,
  UK: HeaderUK,
  FI: HeaderFI,
} satisfies Record<Country, LazyExoticComponent<() => JSX.Element>>;

const Layout = ({ children }: { children: ReactNode }) => {
  const viewportHeight = use100vh();

  const Header = HeaderCountryMap[getConfig().country];

  return (
    <div
      className={cn(
        'min-h-dvh',
        '[--layout-horizontal-padding:16px]',
        '[--header-height:56px] lg:[--header-height:64px]',
        '[--main-padding-bottom:24px] lg:[--main-padding-bottom:80px]',
        '[--layout-max-width:600px] has-data-[layout-legacy=true]:[--layout-max-width:1128px]',
      )}
      style={
        {
          '--100dvh': viewportHeight ? `${viewportHeight}px` : '100vh',
        } as CSSProperties
      }
    >
      <Header />

      <main
        className={cn(
          'relative mx-auto flex min-h-[calc(100dvh-var(--header-height))] w-full max-w-(--layout-max-width) flex-col px-(--layout-horizontal-padding) pb-(--main-padding-bottom)',
          // Isolate this element so its contents always appear below the header navigation menu
          'isolate',
        )}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
